import { jsxs as e, jsx as r } from "react/jsx-runtime";
import { Icon as t } from "../Icon/Icon.js";
const n = (c) => {
  const { className: o } = c;
  return /* @__PURE__ */ e(t, { viewBox: "-32 -32 64 64", titleAccess: "Loading", className: o, children: [
    /* @__PURE__ */ r("circle", { cx: "0", cy: "0", r: "28", fill: "currentColor", strokeWidth: "3" }),
    /* @__PURE__ */ r("circle", { cx: "0", cy: "0", r: "28", fill: "currentColor", strokeWidth: "3" })
  ] });
};
export {
  n as SpinnerIcon
};
